import React from 'react'
import { NavLink } from "react-router-dom"

class NavLinkOrA extends React.Component {
  render() {
    if(this.props.is404) {
      return <a onClick={this.props.onClick} className="a404" href={this.props.to}>{this.props.children}</a>
    } else {
      return <NavLink onClick={this.props.onClick} to={this.props.to} activeClassName={this.props.activeClassName}>{this.props.children}</NavLink>
    }
  }
}

export default NavLinkOrA


// WEBPACK FOOTER //
// ./src/components/snippets/NavLinkOrA.jsx